/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ILicencaListDto, IListaLicencaDTO } from "../../../Dtos/Comercial/Licencas/LicencasDtos";
import ApiService from "../../../Config/ApiConfig";
import { ActionButton, Card, CardActions, CardField, CardView } from "../../../Components/CardView/CardView";
import { Edit } from "lucide-react";
import LoadingPage from "../../../Components/Loading/Loading";
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table";
import AppLayout from "../../../Components/Layout/Layout";
import { TopActions } from "../../../Components/TopActions/TopActions";
import Pagination from "../../../Components/Pagination/Pagination";
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast";
import { credencialTemAcesso } from "../../../Components/Layout/MenuData";

export const ListaLicencaPage = () => {
    const navigate = useNavigate()
    const [sd42s, setSd42s] = useState<ILicencaListDto[]>([])
    const [filter, setFilter] = useState('');
    const [quantity, setQuantity] = useState('13');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Licenças" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        buscarLicencas()
    }, [currentPage, quantity, filter])

    const buscarLicencas = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const sd01s = await apiService.get<IListaLicencaDTO>("/sd42Controller/buscarLicencas", {
                params: {
                    currentPage,
                    qtd: quantity,
                    filter: filter
                }
            })

            const pages = Math.ceil(sd01s.count / Number(quantity));

            setSd42s(sd01s.values)
            setTotalPage(pages)

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar licenças! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (id: number) => {
        navigate("/licenca/" + id)
    };

    const handleFiltrar = (filtro: string, qtd: string) => {
        setFilter(filtro);
        setQuantity(qtd);
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    const renderMobileView = () => (
        <CardView>
            {sd42s.map(sd42 => (
                <Card key={sd42.sd42id}>
                    <CardField>
                        <label>Representante</label>
                        <span>{sd42.sd41codigo}</span>
                    </CardField>
                    <CardField>
                        <label>Nome do Representante</label>
                        <span>{sd42.sd41nome}</span>
                    </CardField>
                    <CardField>
                        <label>Cliente(CNPJ)</label>
                        <span>{sd42.sd40cnpj}</span>
                    </CardField>
                    <CardField>
                        <label>Nome do Cliente</label>
                        <span>{sd42.sd40nome}</span>
                    </CardField>
                    <CardActions>
                        <ActionButton onClick={() => handleEdit(sd42.sd42id!)} disabled={!credencialTemAcesso("licenças", "sd031acessa")}>
                            <Edit size={16} />
                        </ActionButton>
                    </CardActions>
                </Card>
            ))}
        </CardView>
    );

    const renderDesktopView = () => (
        <TableContainer>
            <Table>
                <thead>
                    <tr>
                        <Th>#</Th>
                        <Th>representante</Th>
                        <Th>Nome do representante</Th>
                        <Th>Cliente(CNPJ)</Th>
                        <Th>Nome do cliente</Th>
                        <Th>Operações</Th>
                    </tr>
                </thead>
                <tbody>
                    {sd42s.map(sd42 => (
                        <tr key={sd42.sd42id}>
                            <Td>{sd42.sd42id}</Td>
                            <Td>{sd42.sd41codigo}</Td>
                            <Td>{sd42.sd41nome}</Td>
                            <Td>{sd42.sd40cnpj}</Td>
                            <Td>{sd42.sd40nome}</Td>
                            <Td >
                                <ActionButton onClick={() => handleEdit(sd42.sd42id!)} disabled={!credencialTemAcesso("licenças", "sd031acessa")}>
                                    <Edit size={16} />
                                </ActionButton>
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableContainer>
    );

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <TopActions
                disabled
                filter={filter}
                quantity={quantity}
                handleAddNew={() => { }}
                filtrar={handleFiltrar}
            />
            {isMobile ? renderMobileView() : renderDesktopView()}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPage}
                onPageChange={setCurrentPage}
            />
        </AppLayout>
    );
}